import { getApiRequest } from '@/utils'
import type { IRes, IResList, IPage } from '@/types'

const request = getApiRequest()

//获取用户信息
export async function getUserInfo() {
  return request.post<IRes<IResList<unknown>>>('/collector/api/user/info?getMore=1&get_system_messages=1')
}

//获取用户类型
export async function getUserType() {
  return request.get<IRes<IResList<unknown>>>('/design/customer/getCustomerType')
}

// feedback
export async function feedback(data: any) {
  return request.post<IRes<IResList<unknown>>>('/api/feedback_submit', data)
}

//记录用户登录
export async function userLoginLog(query: any) {
  return request.get<IRes<IResList<unknown>>>('/design/customer/recordLogin', { params: query })
}
